import React from 'react';
import _ from 'lodash';

import { Chip } from '@mui/material';
import { OrderStatusName } from 'generated/graphql';



export interface IProps {
  status: OrderStatusName;
  variant?: 'button' | 'default';

  isSelected?: boolean;
  onClick?: () => void;
}

export const FC: React.FC<IProps> = props => {
  const useOutlinedVariant = !_.isNil(props.isSelected) && !props.isSelected;

  return (
    <Chip
      size={props.variant ==='button' ? 'medium' : 'small'}
      color={props.variant === 'button' ? 'default' : __statusName2Color[props.status]}
      label={__statusName2Label[props.status]}
      variant={useOutlinedVariant ? 'outlined' : 'filled'}
      onClick={props.onClick} />
  );
};



const __statusName2Label: Record<OrderStatusName, string> = {
  cancelled: "Cancelled",
  completed: "Completed",
  failed: "Failed",
  onHold: "On-Hold",
  pending: "Pending",
  processing: "Processing",
  refunded: "Refunded"
};

const __statusName2Color: Record<OrderStatusName, 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'> = {
  cancelled: 'error',
  failed: 'error',
  refunded: 'secondary',

  completed: 'success',
  onHold: 'default',
  processing: 'warning',
  pending: 'info'
};
